<!-- 人员通行记录页面 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="section-mian_right">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="accessTab"
            :data="tableData"
            :option="tableOption"
            :page="page"
            @row-cancle="closeDialog"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @size-change="changeSize"
          >
            <!-- 搜索框 自定义 -->
            <template slot="search_passageTime">
              <div>
                <el-date-picker
                  type="datetime"
                  placeholder="请选择开始时间"
                  v-model="searchParams.startTime"
                  default-time="00:00:00"
                  style="width: 182px"
                ></el-date-picker>
                <span style="padding: 0 5px">至</span>
                <el-date-picker
                  type="datetime"
                  placeholder="请选择结束时间"
                  v-model="searchParams.endTime"
                  default-time="23:59:59"
                  style="width: 182px"
                ></el-date-picker>
              </div>
            </template>
            <template slot="search_areaDevGroupCode">
              <div style="flex: 1; position: relative; margin-right: 20px">
                <!-- <el-cascader
                  v-model="areaDevGroupValue"
                  :options="optionCasacder"
                  :props="casacderProps"
                  :show-all-levels="false"
                  collapse-tags
                  clearable
                  @change="handleChangeCascader"
                >
                  <template slot-scope="{ node, data }">
                    <span v-if="node.isLeaf">{{ data.label }}</span>
                  </template>
                </el-cascader> -->
                <el-select
                  v-model="areaDevGroupValue"
                  placeholder="请选择"
                  multiple
                  collapse-tags
                  @change="selectChange"
                  style="margin-left: 20px"
                >
                  <el-option
                    :value="areaDevGroup"
                    style="height: auto; padding: 0"
                  >
                    <region-tree
                      :isPageTree="true"
                      :isSerch="false"
                      @handleCheckChange="handleCheckChange"
                      ref="regionTree"
                    />
                  </el-option>
                </el-select>
              </div>
            </template>
            <!-- <template slot="menuLeft">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-download"
                @click="exportDocument"
              >
                导出
              </el-button>
            </template> -->
            <!-- 表格按钮 自定义 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
            <!-- 表格列 自定义 -->
            <template slot="trafficFileCode" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.trafficFileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
                @click="
                  showViewer(getImgPath(scope.row.trafficFileCode), $event)
                "
              />
            </template>
            <template slot="name" slot-scope="scope">
              <span
                style="cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.name }}</span
              >
            </template>
          </ioc-table>
          <!--详情-->
          <appPanel
            :width="720"
            class="app-panel"
            :isExpand="showPanel"
            @cancel="handleClosePanel"
            title="通行记录详情"
          >
            <div class="panel-content">
              <!-- <div class="detail-photo">
              
                <img
                  style="width: 160px; height: 200px"
                  onerror="this.src='/images/theme/newDark/default.png'"
                  :src="getImgPath(detailForm.personnelFileCode)"
                  @click="
                    showViewer(getImgPath(detailForm.personnelFileCode), $event)
                  "
                />
              </div> -->
              <div class="content-top">
                <div class="detail-info">
                  <div class="info-item">
                    <span class="label">人员姓名：</span>
                    <span class="item-value">{{ detailForm.name }}</span>
                  </div>
                  <!-- <div class="info-item">
                  <span class="label">性别</span>
                  <span class="item-value">{{ detailForm.personnelType }}</span>
                </div> -->
                  <div class="info-item">
                    <span class="label">人员工号：</span>
                    <span class="item-value">{{ detailForm.jobNo }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">验证方式：</span>
                    <span class="item-value">{{
                      detailForm.verifyModeName
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">门禁区域：</span>
                    <span class="item-value">{{
                      detailForm.areaDevGroupName
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">设备名称：</span>
                    <span class="item-value">{{ detailForm.deviceName }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">读头名称：</span>
                    <span class="item-value">{{ detailForm.readerName }}</span>
                  </div>
                  <div class="info-item_col1">
                    <span class="label">通行时间：</span>
                    <span class="item-value">{{ detailForm.trafficTime }}</span>
                  </div>
                </div>
                <div class="detail-photo">
                  <img
                    style="width: 176px; height: 176px"
                    onerror="this.src='/images/theme/newDark/default.png'"
                    :src="getImgPath(detailForm.trafficFileCode)"
                    @click="
                      showViewer(
                        getImgPath(detailForm.trafficFileCode),
                        $event
                      )
                    "
                  />
                </div>
              </div>
            </div>
            <div slot="footer">
              <el-button @click="handleClosePanel">关闭</el-button>
            </div>
          </appPanel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import appPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api/index";
import { Dic, Bus, Dates } from "$utils";
import utils from "$utils";
import i18n from "@src/common/lib/i18n";
import regionTree from "@src/components/business/app-area-tree";
import { tableOption } from "../config/table";
export default {
  components: {
    regionTree,
    appPanel,
  },
  data() {
    return {
      detailForm: {},
      showPanel: false,
      tableOption: tableOption(),
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      // 员工用户组列表查询参数
      searchParams: {},
      areaDevGroupValue: [],
      areaDevGroup: [],
      optionCasacder: [],
      casacderProps: { multiple: true },
      getTimeOut: null,
    };
  },
  beforeDestroy() {
    this.getTimeOut && clearTimeout(this.getTimeOut);
  },
  created() {},
  mounted() {
    this.getList();
    this.getAreaTree();
  },
  methods: {
    handSetTime() {
      if (this.getTimeOut) {
        clearTimeout(this.getTimeOut);
      }
      this.getTimeOut = setTimeout(() => {
        this.getList();
      }, 1000 * 60 * 2);
    },
    selectChange(e) {
      var arrNew = [];
      for (let i = 0; i < e.length; i++) {
        for (let j = 0; j < this.areaDevGroup.length; j++) {
          if (e[i] === this.areaDevGroup[j].areaDevGroupName) {
            arrNew.push(this.areaDevGroup[j]);
          }
        }
      }
      this.$refs.regionTree.$refs.dialogTree.setCheckedNodes(arrNew); //设置勾选的值
    },

    handleCheckChange(data, isCheck) {
      let arrLabel = [];
      let arr = [];
      let res = this.$refs.regionTree.$refs.dialogTree.getCheckedNodes(
        false,
        false
      );
      res.forEach((item) => {
        arrLabel.push(item.areaDevGroupName);
        arr.push({
          areaDevGroupName: item.areaDevGroupName,
          areaDevGroupCode: item.areaDevGroupCode,
        });
      });
      this.areaDevGroupValue = arrLabel;
      this.areaDevGroup = arr;
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(src,e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 获取区域树结构
    getAreaTree() {
      const self = this;
      const account = utils.Cache.get("CACHE_USER_INFO");
      let params = {
        accountNumber: account.account,
      };
      this.$fetch(api.person.areaList, params).then((res) => {
        if (res.success) {
          this.optionCasacder = this.menusDataPro(res.returnObj);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.value = item.areaDevGroupCode;
          entity.label = item.areaDevGroupName;
          entity.lng = item.lng;
          entity.lat = item.lat;
          entity.desc = item.desc;
          entity.parentCode = item.parentCode;
          entity.personList = [].concat(item.ownerList);
          entity.ownerList = self.showOwnerList(item.ownerList);
          entity.isLeaf = !item.hasLeaf || !item.childrens;
          if (item.childrens) {
            entity.children = self.menusDataPro(item.childrens);
          }
          result.push(entity);
        });
        return result;
      }
    },
    //导出
    exportDocument() {},
    showOwnerList(list) {
      return list.map((item) => item.personnelName).join(",");
    },
    // 级联下拉框change事件
    handleChangeCascader(value) {},
    // 获取列表
    getList() {
      console.log(this.searchParams, "==this.searchParams");
      const params = {};
      let result = [];
      // this.areaDevGroupValue.forEach((item) => {
      //   result.push(item[item.length - 1]);
      // });
      this.areaDevGroup.forEach((item) => {
        result.push(item.areaDevGroupCode);
      });
      params.areaDevGroupCodeList = result;
      params.name = this.searchParams.name;
      params.deviceName = this.searchParams.deviceName;
      params.trafficType = this.searchParams.trafficType;
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      params.verifyModeName = this.searchParams.verifyModeName;
      // params.trafficTime = this.searchParams.trafficTime
      //   ? Dates.format(this.searchParams.trafficTime)
      //   : "";
      params.beginTime = this.searchParams.startTime
        ? Dates.format(this.searchParams.startTime)
        : "";
      params.endTime = this.searchParams.endTime
        ? Dates.format(this.searchParams.endTime)
        : "";

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.person.getRecordList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.handSetTime();
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },

    handleView(row, index) {
      this.showPanel = true;
      this.detailForm = row;
    },
    handleClosePanel() {
      this.showPanel = false;
    },
    closeDialog() {},

    // 查询按钮事件
    searchResult(param) {
      this.searchParams = param;
      // let tempObj = {};
      // tempObj.startTime = this.searchParams.startTime;
      // tempObj.endTime = this.searchParams.endTime;

      // this.searchParams = Object.assign(param);
      // console.log(this.searchParams, "===query");
      if (param.passageTime && param.passageTime.length > 0) {
        this.searchParams.startTime = param.passageTime[0];
        this.searchParams.endTime = param.passageTime[1];
      }

      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.areaDevGroupValue = this.areaDevGroup = [];
      console.log(this.searchParams, "==paras");
      this.searchParams = "";
      //  this.$refs.regionTree.$refs.dialogTree.setCheckedKeys([]);
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
/deep/.nodialog {
  height: 250px !important;
}
/deep/.ioc-theme .el-select-dropdown__list {
  padding-top: 0 !important;
}
.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .detail-photo {
    width: 176px;
    margin: 17px 81px 0;
  }
  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }
  .item-img {
    margin: 15px 0px;
  }
  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }
  .info-item_col1 {
    margin: 15px 0px;
    width: 100%;
  }
  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}
.access-record-container {
  width: 100%;
  height: 100%;
  .el-table__fixed-right-patch {
    display: none;
  }
  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}
</style>
